/** * @file buildPdpSuggestedSearchesOptions.js
 * @description Builds an array of suggested search options for the PDPSuggestedSearches component.
 * Each option is an object with a key and a title.
 * The options are based on the provided product attributes such as color family, l1, l2, l3,
 * occasion, dressing style, and product type.
  * @param {Object} pdpAttributesObj - The product attributes object containing
  * details like l1, l2, l3, etc.
  * @param {string} allL2sSearchButtonText - The text for the "All L2s" search button.
  * @return {Array} An array of objects representing the suggested search options.
  * Each object has a 'key' and a 'title'.
 */

const buildPdpSuggestedSearchesOptions = (pdpAttributesObj, allL2sSearchButtonText) => {
  // Using L1 info in titles below instead of the "gender" databridge attribute (more descriptive)
  const pdpSuggestedSearchesOptionsArray = [];
  const {
    colorFamily, l1, l2, l3, occasion, dressingStyle, productType,
  } = pdpAttributesObj || {};

  if (colorFamily && l3) {
    pdpSuggestedSearchesOptionsArray.push({
      key: 'l3ForColorFamily',
      title: `${colorFamily} ${l3}`,
    });
  }
  if (l1 && l3) {
    pdpSuggestedSearchesOptionsArray.push({
      key: 'l3ForL1',
      title: `${l1} ${l3}`,
    });
  }
  if (l1 && l2 && allL2sSearchButtonText) {
    pdpSuggestedSearchesOptionsArray.push({
      key: 'allL2',
      title: `${allL2sSearchButtonText}`,
    });
  }
  if (occasion && l2) {
    pdpSuggestedSearchesOptionsArray.push({
      key: 'l2ForOccasion',
      title: `${occasion} ${l2}`,
    });
  }
  if (l1 && dressingStyle && productType) {
    pdpSuggestedSearchesOptionsArray.push({
      key: 'l1ForDressingStyleAndProductType',
      title: `${l1} ${dressingStyle} ${productType}`,
    });
  }

  return pdpSuggestedSearchesOptionsArray;
};

export default buildPdpSuggestedSearchesOptions;
